<template>
  <SkeletonLoader class="list-display-loader">
    <div class="list-display-loader__content" />
    <div class="list-display-loader__value" />
  </SkeletonLoader>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

import { SkeletonLoader } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    SkeletonLoader
  }
})
export default class ListDisplayLoader extends Vue {}
</script>

<style lang="less" scoped>
.list-display-loader {
  display: flex;
  justify-content: space-between;

  &__content {
    width: 30%;
    height: 26px;
    border-radius: @size-radius-x100;
  }

  &__value {
    width: 50%;
    height: 26px;
    border-radius: @size-radius-x100;
  }
}
</style>
